import { useCallback, useState } from 'react';

import { DirectUpload } from "@rails/activestorage";

const UPLOAD_URI = document.querySelector('meta[name="rails-direct-upload-url"]')?.getAttribute('content');

type BlobType = {
  signed_id: string,
  id: number,
  filename: string,
  created_at: string
}

type DirectUploadResult = [
  upload: (file: File) => Promise<BlobType>,
  status: { loaded: number, total: number, loading: boolean }
]

const useDirectUpload = (): DirectUploadResult => {
  const [ loaded, setLoaded ] = useState(0);
  const [ total, setTotal ] = useState(0);

  const upload = useCallback((file: File) => {
    const uploader = new DirectUpload(file, UPLOAD_URI, {
      directUploadWillStoreFileWithXHR: (request) => {
        request.upload.addEventListener("progress", ({ loaded, total }) => {
          setLoaded(loaded);
          setTotal(total);
        });
      }
    });

    return new Promise<BlobType>((resolve, reject) => {
      uploader.create((error, blob) => {
        if (error) {
          reject(error);
        }
        else if (blob) {
          resolve(blob);
        }
      });
    })
  }, []);

  return [ upload, { loaded, total, loading: (loaded !== total) } ];
}

export default useDirectUpload;
